import React, { useState, useEffect, useCallback } from 'react'
import { Template } from '../../Components/Template/template'
import { Icone } from '../../Components/Icones/Index'
import { faFilter } from '@fortawesome/free-solid-svg-icons'
import { IoSearch, IoAddCircleSharp, IoCloseCircleOutline } from 'react-icons/io5'
import { Link, useNavigate } from 'react-router-dom'
import {
    classDivBackground, classDivBody, classDivTitulo, classInput, classInputDark, classLabel,
    classLabelDark, classbtColunasAzul, classbtVerde, Parceiro, classBorderLabelDark, classBtSemDuration, classbtCinzaClaro, AlertType
} from '../../Utils/Types'
import { ParceiroService } from './ParceiroService'
import { GridParceiros } from '../../Components/GridProducts/GridParceiros'
import { AiOutlineClear } from 'react-icons/ai'
import { ImUserTie } from 'react-icons/im'
import { FeedbackMessage } from '../../Components/FeedbackMessage/feedback-message'
import { Funcoes } from '../../Utils/Funcoes'

export const ParceiroPage = () => {

    // ---------- ATRIBUTOS FEEDBACK -----------------
    const [visible, setVisible] = useState(false)
    const [loading, setLoading] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("DANGER")

    // ---------- ATRIBUTOS FILTRO -------------------
    const [field, setField] = useState("razao")
    const [filterType, setFilterType] = useState('start')
    const [filter, setFilter] = useState('')

    // ---------- ATRIBUTOS GRID ---------------------
    const [parceiros, setParceiros] = useState<Parceiro[]>([])

    //------------------------------------------------------------------------------------------ REQUISIÇÃO API, ATALHOS E USEEFFECT ---------------------------------------------------------------------//
    const getParceiros = async () => {
        setLoading(true)

        try {

            const parceiro = await ParceiroService.Filter(field, filterType, filter)
            setParceiros(parceiro.data)

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage(`Não foi possível buscar as informações`)

        } finally {

            const timer = setTimeout(() => {
                setLoading(false)
                clearTimeout(timer)
            }, 0)

        }
    }

    const handleMouseUp = useCallback((e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        // Desfocar o link após o clique
        const target = e.target as HTMLElement
        if (target instanceof HTMLAnchorElement) {
            target.blur()
        }

        inputFocus()
    }, [])

    const handleKeyPressEnter = async (e: any) => {

        let menuFiltro = document.getElementById("divMenuFiltroParceiros") as HTMLDivElement

        if ((e.code === "Enter" || e.code === "NumpadEnter") && !loading && menuFiltro.classList.contains("max-h-[390px]")) {
            await handleFilterClick()
        }
    }

    const handleTabPress = (event: any) => {

        if (event.key === 'Tab') {
            event.preventDefault() // Evita o comportamento padrão do 'Tab'
        }
    }

    useEffect(() => {
        document.addEventListener('keydown', handleTabPress)
        document.addEventListener('keydown', handleKeyPressEnter)

        return () => {
            document.removeEventListener('keydown', handleTabPress)
            document.removeEventListener('keydown', handleKeyPressEnter)
        }
    }, [filter, filterType, field, loading])

    useEffect(() => {
        getParceiros()
    }, [])

    const inputFocus = () => {
        const inputElement = document.getElementById("pesquisa_parceiro")
        inputElement?.focus()
    }

    const inputDesfocus = () => {
        const inputElement = document.getElementById("pesquisa_parceiro")
        inputElement?.blur()
    }

    const handleCloseMessage = () => {
        setVisible(false)
    }

    //--------------------------------------------------------------------------------------------- FILTROS -----------------------------------------------------------------------------------//
    const handleChangeField = (e: React.ChangeEvent<HTMLSelectElement>) => {

        const fieldMap: { [key: string]: string } = {
            'razao': 'razao',
            'nome_fantasia': 'nome_fantasia',
            'cnpj_cpf': 'cnpj_cpf',
        }

        const selectedField = fieldMap[e.target.value]

        if (selectedField) {
            setField(selectedField)
            inputFocus()
        }

    }

    const handleFilterTypeChange = async (e: React.ChangeEvent<HTMLSelectElement>) => {
        const filterMap: { [key: string]: string } = {
            'start': 'start',
            'equals': 'equals',
            'contains': 'contains',
        }

        const selectedFilter = filterMap[e.target.value]

        if (selectedFilter) {
            setFilterType(selectedFilter)
            inputFocus()
        }
    }

    const handleChangeFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (field === 'cnpj_cpf') {

            const value = e.target.value.replace(/[^0-9]/g, '')
            const numericValue = Funcoes.onlyNumber(value.replace(/[./-]/g, ''))

            setFilter(value)

            if (numericValue.length === 11 || numericValue.length === 14) {
                const formattedDoc = Funcoes.FormatDoc(numericValue)
                setFilter(formattedDoc || value)
            }

        } else {
            setFilter(e.target.value)
        }
    }

    useEffect(() => {

        if (field === 'cnpj_cpf') {

            setFilter(filter.replace(/[^0-9]/g, '').slice(0, 14))
            const numericValue = Funcoes.onlyNumber(filter.replace(/[./-]/g, '').slice(0, 14))

            if (numericValue.length === 11 || numericValue.length === 14) {
                const formattedDoc = Funcoes.FormatDoc(numericValue)
                setFilter(formattedDoc || filter)
            }

        }

    }, [field])

    const handleFilterClick = async () => {

        setVisible(false)
        setLoading(true)
        setParceiros([])
        inputDesfocus()

        try {

            const parceiros = await ParceiroService.Filter(field, filterType, filter.replace(/[./-]/g, ''))
            setParceiros(parceiros.data)

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage(`Não foi possível buscar os parceiros`)

        } finally {

            const timer = setTimeout(() => {
                inputFocus()
                setLoading(false)
                clearTimeout(timer)
            }, 1500)
        }
    }

    const filterDados = useCallback(async () => {

        setVisible(false)

        try {

            const parceiros = await ParceiroService.Filter(field, filterType, filter.replace(/[./-]/g, ''))
            setParceiros(parceiros.data)

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage(`Não foi possível buscar os parceiros`)
            setParceiros([])
        }

    }, [parceiros, field, filterType, filter])

    const limparCampoFilter = () => {
        setFilter("")
        inputFocus()
    }

    const toggleMenuFiltro = (event: any) => {

        let menuFiltro = document.getElementById("divMenuFiltroParceiros") as HTMLDivElement

        let menuInputs = document.getElementById("divInputsParceiros") as HTMLDivElement

        if (menuFiltro) {

            menuFiltro.classList.toggle("max-h-[390px]")
            menuFiltro.classList.toggle("max-h-[0px]")

            if (menuFiltro.classList.contains("max-h-[390px]")) {

                menuInputs.classList.remove("invisible")

                const timer = setTimeout(() => {
                    inputFocus()
                    clearTimeout(timer)
                }, 150)

            } else {

                menuInputs.classList.add("invisible")
            }

            event.currentTarget.blur()
        }
    }

    // -------------------------------------------------------------------------------------- NAVEGAÇÃO ------------------------------------------------------------
    const navigate = useNavigate()

    const navegarTelaParceiros = () => {
        //navigate("/parceiros/new")
    }

    return (
        <Template isLoading={loading}>

            <div className={`${classDivBackground}`}>

                <FeedbackMessage visible={visible} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                <div role='button' id="div-body" className={`${classDivBody}`}>

                    <div className={`${classDivTitulo} grid grid-cols-12 gap-4 p-2`}>

                        <div className={`relative col-span-9 sm:col-span-6 md:col-span-6 xl:col-span-8 flex flex-row items-center`}>
                            <ImUserTie className={`mr-2 ml-2 h-9 text-slate-700 dark:text-slate-200`} size="25px" />
                            <span className={`text-base md:text-lg xl:text-2xl text-slate-700 dark:text-slate-200`}>Parceiros</span>
                        </div>

                        <div className={`relative col-span-6 sm:col-span-3 md:col-span-3 xl:col-span-2`}>
                            <button tabIndex={-1} className={`${classbtColunasAzul} h-9`} onClick={toggleMenuFiltro} >
                                <span className={`w-full h-full flex justify-center items-center`}>Filtros</span>
                            </button>
                        </div>

                        <div className={`relative col-span-6 sm:col-span-3 md:col-span-3 xl:col-span-2`}>

                            <Link tabIndex={-1} onMouseUp={handleMouseUp} to={'/parceiros/new'} className={`${classBtSemDuration} ${classbtVerde} h-9`} >
                                <IoAddCircleSharp className={`mx-2 hidden md:block`} size="20px" /> Cadastro
                            </Link>

                            {/*
                            <button tabIndex={-1} className={`${classBtSemDuration} ${classbtVerde} h-9`} onClick={navegarTelaParceiros}>
                                <IoAddCircleSharp size="20px" className='mr-2 hidden md:block' /> Cadastro
                            </button>
                            */}

                        </div>

                    </div>

                    <div id='divInputsParceiros' className={`relative invisible ease-in-out duration-[150ms]`}>

                        <div id='divMenuFiltroParceiros' className={`relative max-h-[0px] h-[390px] sm:h-[160px] cursor-default bg-white dark:bg-slate-600 shadow-sm shadow-slate-400 dark:shadow-slate-800 border dark:border-slate-800 rounded-md overflow-y-hidden`} style={{ transitionDuration: "0ms, 300ms", transitionProperty: "background-color, max-height" }} />

                        <div className={`absolute top-0 w-full h-auto grid grid-cols-12 gap-3 py-7 px-3`}>

                            <div className={`relative col-span-12 sm:col-span-3 xl:col-span-2 mt-3 sm:mt-0`}>
                                <select id='filter_to' disabled={loading} className={`${classInput} ${classInputDark}`} value={field} onChange={handleChangeField} >
                                    <option value="razao">RAZÃO SOCIAL / NOME</option>
                                    <option value="nome_fantasia">NOME FANTASIA / APELIDO</option>
                                    <option value="cnpj_cpf">CPF / CNPJ</option>
                                </select>
                                <label htmlFor="filter_to" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}><Icone icon={faFilter} /><span className='ml-2'>Filtrar por</span></label>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-3 xl:col-span-2 mt-3 sm:mt-0`}>
                                <select id='filter_type' disabled={loading} className={`${classInput} ${classInputDark}`} value={filterType} onChange={handleFilterTypeChange}>
                                    <option value="start">INICIA COM</option>
                                    <option value="equals">IGUAL A</option>
                                    <option value="contains">CONTÉM</option>
                                </select>
                                <label htmlFor="filter_type" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Critério</label>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-6 xl:col-span-8 mt-3 sm:mt-0`}>
                                <input id="pesquisa_parceiro" className={`${classInput} ${classInputDark} pr-10`} type="text" inputMode={field === 'cnpj_cpf' ? 'numeric' : 'text'} maxLength={field === 'cnpj_cpf' ? 18 : 999} placeholder=' ' autoComplete="off" value={filter} onChange={handleChangeFilter} />
                                <label htmlFor="pesquisa_parceiro" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Digite sua consulta</label>
                                <button onClick={limparCampoFilter} className={`absolute right-2 bottom-0 top-0 text-slate-400 outline-none ${filter === '' ? 'invisible' : 'visible'}`}>
                                    <IoCloseCircleOutline size="25px" />
                                </button>
                            </div>

                            <div className={`col-span-12 flex flex-col sm:flex-row justify-end sm:space-x-2 mt-3`}>

                                <div className={`relative mt-2 sm:mt-0`}>
                                    <button className={`${classBtSemDuration} ${classbtCinzaClaro} w-full sm:min-w-[150px]`} onClick={limparCampoFilter}>
                                        <AiOutlineClear size="20px" className={`mr-[2px]`} /><span className='mx-1'>Limpar Campos</span>
                                    </button>
                                </div>

                                <div className={`relative mt-6 sm:mt-0`}>
                                    <button disabled={loading} className={`${loading ? `opacity-40` : ``} ${classbtColunasAzul} w-full sm:min-w-[150px]`} onClick={handleFilterClick} >
                                        <span className={`w-full h-full flex justify-center items-center`}>
                                            {!loading && <IoSearch size="20px" className={`mr-2`} />}
                                            {loading &&
                                                <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-[#2980b9] dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                    <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                                </div>
                                            }
                                            {!loading && `Pesquisar`} {loading && `Aguarde`}
                                        </span>
                                    </button>
                                </div>



                            </div>

                        </div>

                    </div>

                    <div className={`w-full cursor-default mt-1 z-0 border shadow-sm shadow-slate-400 bg-white dark:bg-slate-600 dark:border-slate-800 dark:shadow-slate-800`}>
                        <GridParceiros parceiro={parceiros} handleUpdateParceiroList={filterDados} />
                    </div>

                </div>

            </div>

        </Template>
    )
}